import { Spinner } from "views/mobile/components/common";
import Icon, { Icons } from "react-hp-icons";
import React from "react";
import styled from "styled-components";

export const FlatButton = ({
	text,
	color,
	name,
	onClick,
	onChange,
	disabled,
	loading,
	buttonStyle,
	icon = "right",
	outlined,
}) => {
	/*
	const handleClick = e => {
		onChange({target: {name, value: true}});
		onClick(e);
	}
	*/
	return (
		<Wrapper
			loading={loading}
			onClick={disabled || loading ? null : onClick}
			color={disabled ? "disabled" : color}
			style={buttonStyle}
			outlined={outlined}
		>
			{loading ? (
				<Spinner color="#fff" button size="small" />
			) : (
				<Text>{text}</Text>
			)}
			{!loading && <Icon type={Icons[icon]} size={1} />}
		</Wrapper>
	);
};

const whichColor = (prop) => (props) => {
	switch (props[prop]) {
		case "primary":
			return "#145ab4";
		case "secondary":
			return "#7e2f87";
		case "disabled":
			return "grey";
		default:
			return "#145ab4";
	}
};

const Text = styled.div``;

const Wrapper = styled.div`
	background-color: ${whichColor("color")};
	border-radius: 4px;
	width: ${(props) => (props.style && props.style.width) || "290px"};
	height: 40px;
	color: #fff;
	font-weight: 600;
	font-size: 14px;
	cursor: pointer;

	${(props) =>
		props.outlined &&
		"cursor: pointer;border: 2px solid #7e2f87;color: #7e2f87;background: transparent;border-radius: 10px;font-size: 14px;"}

	& > div {
		display: inline-block;
		width: 8%;
		line-height: 40px;
	}

	& > div:first-child {
		text-align: center;
		width: ${(props) => (props.loading ? "100%" : "92%")};
	}

	& path {
		fill: #fff !important;
	}
`;
